<template>
  <v-container class="page-container p-3">
    <ApplicationManagementContainer />
  </v-container>
</template>

<script>
import ApplicationManagementContainer from "@/components/Container/ApplicationManagementContainer.vue"
export default {
  components: { ApplicationManagementContainer },
}
</script>
